import { Component, OnInit } from '@angular/core';
import { ModalController,  AlertController, NavParams, NavController, ToastController } from '@ionic/angular';
import * as firebase from 'firebase';
import { Router, NavigationExtras } from '@angular/router';
import { DatabaseService } from '../service/database.service';
@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.page.html',
  styleUrls: ['./add-to-cart.page.scss'],
})
export class AddToCartPage implements OnInit {

  productObject: any ;
  cartCollectionList : any = [];
  productOrderQuantity = 0;
  totalSetQuantity = 0;
  orderQuantityArrayColorWise = {};
  orderQuantityArrayBySize = {};
  orderQuantityArray: any = {};
  activeImageIndex: any;

  constructor( public modalController: ModalController,
    public navParam: NavParams, public toastController: ToastController,
    public alertController: AlertController, public navCtrl: NavController, private router: Router, 
    private dataBaseService: DatabaseService, public toastCtrl       : ToastController) {
      const self = this;
      // initialize..
      this.productObject = this.navParam.get('product');
      if (this.productObject.SizeCollection && this.productObject.ColorCollection) {
        for (let size of this.productObject.SizeCollection) {
          this.orderQuantityArray[size.sizeName] = {};
          for (let color of this.productObject.ColorCollection) {
            this.orderQuantityArray[size.sizeName][color.colorCode] = 0;
          }
          if (this.productObject['sizeColorChecklistType'] == 'anySizeAllColor') {
            this.orderQuantityArrayBySize[size.sizeName] = 0;
          } else if (this.productObject['sizeColorChecklistType'] == 'allSizeAnyColor') {
            for (let color of this.productObject.ColorCollection) {
              this.orderQuantityArrayColorWise[color.colorCode] = 0;
              this.orderQuantityArray[size.sizeName][color.colorCode] = 0;
            }
          } 
        }
      }
      if (this.productObject.CustomSizeCollection) {
        for (let size of this.productObject.CustomSizeCollection) {
          this.orderQuantityArray[size.sizeName] = {};
          for (let color of this.productObject.ColorCollection) {
            this.orderQuantityArray[size.sizeName][color.colorCode] = 0;
          }
          if (this.productObject['sizeColorChecklistType'] == 'anySizeAllColor') {
            this.orderQuantityArrayBySize[size.sizeName] = 0;
          } else if (this.productObject['sizeColorChecklistType'] == 'allSizeAnyColor') {
            for (let color of this.productObject.ColorCollection) {
              this.orderQuantityArrayColorWise[color.colorCode] = 0;
              this.orderQuantityArray[size.sizeName][color.colorCode] = 0;
            }
          } 
        }
      }
    }

  ngOnInit() {
  }

  async close() {
    await this.modalController.dismiss();
  }

  increaseProductQuantity(size, color) {
    if (this.productObject['sizeColorChecklistType'] == 'anySizeAnyColor') {
      this.productOrderQuantity = this.productOrderQuantity + 1;
      // increment orderQuantity
      this.orderQuantityArray[size][color] = this.orderQuantityArray[size][color] + 1;
    } else if (this.productObject['sizeColorChecklistType'] == 'allSizeAllColor') {
      this.totalSetQuantity  = this.totalSetQuantity + 1;
      for (let size of this.productObject.SizeCollection) {
        for (let color of this.productObject.ColorCollection) {
          this.orderQuantityArray[size.sizeName][color.colorCode] = (this.orderQuantityArray[size.sizeName][color.colorCode]) + 1;
          this.productOrderQuantity = this.productOrderQuantity + 1;
        }
      }
    } else if (this.productObject['sizeColorChecklistType'] == 'anySizeAllColor') {
      this.orderQuantityArrayBySize[size] = this.orderQuantityArrayBySize[size] + 1;
      for (let color of this.productObject.ColorCollection) {
        this.orderQuantityArray[size][color.colorCode] = this.orderQuantityArray[size][color.colorCode] + 1
        this.productOrderQuantity = this.productOrderQuantity + 1;
      }
    } else if (this.productObject['sizeColorChecklistType'] == 'allSizeAnyColor') {
      this.orderQuantityArrayColorWise[color] = this.orderQuantityArrayColorWise[color] + 1;
      for (let size of this.productObject.SizeCollection) {
        this.orderQuantityArray[size.sizeName][color.colorCode] = this.orderQuantityArray[size.sizeName][color.colorCode] + 1
        this.productOrderQuantity = this.productOrderQuantity + 1;
      }
    } else {
      this.productOrderQuantity  = this.productOrderQuantity + 1;
    }
  }

  decreaseProductQuantity(size, color) {
    if (this.productObject['sizeColorChecklistType'] == 'anySizeAnyColor') {
      this.productOrderQuantity = this.productOrderQuantity - 1;
      // increment orderQuantity
      this.orderQuantityArray[size][color] = this.orderQuantityArray[size][color] - 1;
    } else if (this.productObject['sizeColorChecklistType'] == 'allSizeAllColor') {
      this.totalSetQuantity  = this.totalSetQuantity - 1;
      for (let size of this.productObject.SizeCollection) {
        for (let color of this.productObject.ColorCollection) {
          this.orderQuantityArray[size.sizeName][color.colorCode] = (this.orderQuantityArray[size.sizeName][color.colorCode]) - 1;
          this.productOrderQuantity = this.productOrderQuantity - 1;
        }
      }
    } else if (this.productObject['sizeColorChecklistType'] == 'anySizeAllColor') {
      this.orderQuantityArrayBySize[size] = this.orderQuantityArrayBySize[size] - 1;
      for (let color of this.productObject.ColorCollection) { 
        this.orderQuantityArray[size][color.colorCode] = this.orderQuantityArray[size][color.colorCode] - 1;
        this.productOrderQuantity = this.productOrderQuantity - 1;
      }
    } else if (this.productObject['sizeColorChecklistType'] == 'allSizeAnyColor') {
      this.orderQuantityArrayColorWise[color] = this.orderQuantityArrayColorWise[color] - 1;
      for (let size of this.productObject.SizeCollection) {
        this.orderQuantityArray[size.sizeName][color] = this.orderQuantityArray[size.sizeName][color] - 1;
        this.productOrderQuantity = this.productOrderQuantity - 1;
      }
    } else {
      this.productOrderQuantity  = this.productOrderQuantity - 1;
    }
  }

  //computDecodeURI function for decode the imageURL to the encode format
  computDecodeURI(url) {
    return decodeURIComponent(url);
  }

  //changeImageAfterClick function for chage the iamge after swithc the image
  changeImageAfterClick(imageURL : any, index) {
    if(imageURL != null && imageURL != "") {
      this.activeImageIndex = index;
      (<HTMLInputElement>document.getElementById("productImage")).src = decodeURIComponent(imageURL);
    } else {
    }
  }


  // @Description : addProductInCart add seller product in the cart
	addProductInCart(event:any , product : any ) {
		var self                = this;
    var currentProductId    = product.id;
    var currentBtn          =  event.currentTarget;
    var obj                 : any;
    var subCategoryObject   : any;
    if (!this.productObject['userObjId']) {
      this.productObject['userObjId'] = '';
    }
  
    obj = {
      categoryId                : product.userCategoryId,
      categoryName              : product['categoryObj'] ? product['categoryObj']['categoryName'] : "",
      subCategoryName           : subCategoryObject ? subCategoryObject.name : "" ,
      productDesign             : product.designNumber,
      productOrAlbumOrCatalog   : "product",
      productOrAlbumOrCatalogId : product.id,
      productObject             : product,
      sellerUserId              : product['userObjId'] ? product['userObjId'] : product.userId,
      sellerUserTypeId          : "",
      subCategoryId             : product.userSubCategoryId,
      userTypeId                : "",
      userId                    : String(localStorage.id),
      orderQuantityArray        : this.orderQuantityArray,
      productOrderQuantity      : this.productOrderQuantity,
      totalSetQuantity          : this.totalSetQuantity,
      orderQuantityArrayColorWise : this.orderQuantityArrayColorWise,
      orderQuantityArrayBySize  : this.orderQuantityArrayBySize,
      sellerUserType            : product.selectedSeller ? product.selectedSeller : ''
    }

    if (this.productObject['fixedPrice']) {
      obj['productOrderPrice'] = this.productOrderQuantity * this.productObject['fixedPrice'];
    }
    
    if (currentBtn.style.color == "") {
      if (currentProductId != null && currentProductId != undefined) {
        self.dataBaseService.addToCartProductInFirestore(function(isSuccess, data, alreadyInCart) {
          if (alreadyInCart) {
            self.showToast("Product already in cart.", 'cmnToastSuccesss');
            self.close();
          }
          else if (isSuccess) {
            self.showToast("Product added in cart.", 'cmnToastSuccesss');
            self.close();
            var matched1 = self.cartCollectionList.find(x=>x.id == data.id);
            if (!matched1) {
              self.cartCollectionList.push(data);
            }
            // For usage Update shared product for intermediary/seller
            self.dataBaseService.updateUsage(function(isSuccess) {
            
            },"addToCart",localStorage.id,localStorage.id,1,"addToCart");
          }
        },obj, "");
      }
    } else {
      if(currentBtn.style.color == "black") {
        if (currentProductId != null && currentProductId != undefined) {
          currentBtn.style.color ="hotpink";
          self.dataBaseService.addToCartProductInFirestore(function(isSuccess, data, alreadyInCart) {
            if (alreadyInCart) {
              self.showToast("Product already in cart.", 'cmnToastSuccesss');
              self.close();
            }
            else if (isSuccess) {
              self.showToast("Product added in cart.", 'cmnToastSuccesss');
              self.close();
              var matched1 = self.cartCollectionList.find(x=>x.id == data.id);
              if(!matched1){
                self.cartCollectionList.push(data);
              }
              // For usage Update shared product for intermediary/seller
              self.dataBaseService.updateUsage(function(isSuccess) {
              
              },"addToCart",localStorage.id,localStorage.id,1,"addToCart");
            }
          },obj, "");
        }
      } else {
        if (currentProductId != null && currentProductId != undefined && self.cartCollectionList) {
          self.dataBaseService.productRemoveFromCartCollection(function(isSuccess) {
            if (isSuccess) {
              currentBtn.style.color ="black";

              //remove view cart products from cart collections
              var index3 = self.cartCollectionList.findIndex(x=>x.productOrAlbumOrCatalogId == currentProductId)
              if(index3 != -1){
                  self.cartCollectionList.splice(index3, 1);
              }
              // For usage Update connection for buyer/other/intermediary
              self.dataBaseService.updateUsage(function(isSuccess) {
                  
              },"addToCart",localStorage.id,localStorage.id,1,"removeToCart");
              self.showToast("PRODUCT REMOVED FROM CART", 'cmnToastColor');
            }
          },self.cartCollectionList[0].id, "");
        }
      }
    }
  }

  async showToast(message, css) {
    if (message) {
      const toast = await this.toastCtrl.create({
          message,
          duration: 1500,
          position: 'bottom',
          cssClass: css
      });
      toast.present();
    }
  }

  async presentToast(text, position: any = 'bottom', duration: any = 3000, showCloseButton: any = false) {
    const toast = await this.toastController.create({
      message: text,
      position: position,
      duration: duration,
       buttons: [
        {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }

}
